import {Power1, TimelineLite} from 'gsap';

class Transition {

    constructor(_elem, autoplay = false) {
        this.elem = _elem;
        this.maskSpeed = .8;
        this.tl = new TimelineLite({paused: true});
        this.buildAnimation();

        if (autoplay) {
            this.play()
        }
    }

    animateMasks() {
        console.error('This is an absolute class and should not be called directly. Please create a sub-class and ovveride the animateMasks() method');
    }

    buildAnimation() {
        this.animateMasks();

        if (this.elem.classList.contains('video-bg') && ! isSafari()) {
            this.tl.from(this.elem.querySelector('video'), this.maskSpeed, {
                scale: 1.1,
                ease: Power1.easeOut
            }, 0);
        }

        if (this.elem.classList.contains('image-bg') && ! isSafari()) {
            this.tl.from(this.elem.querySelector('.background'), this.maskSpeed, {
                scale: 1.1,
                ease: Power1.easeOut
            }, 0);
        }

        this.animateContent();
    }

    animateContent() {
        if (this.elem.querySelector('.inner')) {
            this.tl.to(this.elem.querySelector('.inner'), .35, {
                opacity: 1,
                y: 0,
                ease: Power1.easeOut
            }, "-=1");
        }
    }

    play() {
        if( document.querySelector('iframe.google-map') ) {
            let _this = this;
            setTimeout(function () {
                _this.tl.play();
            }, 750)
            return;
        }
        this.tl.play();
    }

    reverse() {
        this.tl.reverse();
        return this;
    }

    onReverseComplete(callback, scope = null) {
        this.tl.eventCallback('onReverseComplete', callback, null, scope);
        return this;
    }

    onComplete( callback, scope = null ) {
        this.tl.eventCallback('onComplete', callback, null, scope);
        return this;
    }

}

function isSafari() {
    return (navigator.userAgent.indexOf('Safari') != -1 && navigator.userAgent.indexOf('Chrome') == -1)
}

export default Transition;